module.exports = __webpack_public_path__ + "static/auto_policy_updates_desktop-8b95542e04287d13b56e564932e9a224.webp";